var render, staticRenderFns
import script from "./base-component.vue?vue&type=script&lang=js&"
export * from "./base-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shu-suzuki/Documents/prj_git/tryt/care-navi/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1dcdf97e', component.options)
    } else {
      api.reload('1dcdf97e', component.options)
    }
    
  }
}
component.options.__file = "js/components/entries/base-component.vue"
export default component.exports